/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('DOMContentLoaded', function() {
  // Find all "ADD TO CART" buttons using the data-pf-type attribute value
  var addToCartButtons = document.querySelectorAll('[data-pf-type="ProductATC"]');

  if (addToCartButtons.length > 0) {
    // Add a click event listener to each button
    addToCartButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        // Use the Shopify JavaScript API to trigger the cart update event
        var event = new CustomEvent('cart:refresh', {
          bubbles: true
        });

        // Trigger a fetch request to update the cart after a delay
        setTimeout(function() {
          fetch('/cart?view=drawer&timestamp=' + Date.now(), {
            credentials: 'same-origin',
            method: 'GET'
          })
          .then(function(response) {
            return response.text();
          })
          .then(function(html) {
            // Update the cart content
            document.getElementById("sidebar-cart").innerHTML = html;
            document.getElementById("sidebar-cart").children[0].setAttribute("aria-hidden", "false");
            
            // Dispatch the custom event for cart refresh
            document.documentElement.dispatchEvent(event);
          })
          .catch(function(error) {
            console.error('Error updating cart:', error);
          });
        }, 500); // Adjust the delay time as needed
      });
    });
  } else {
    console.error('Could not find any "ADD TO CART" buttons.');
  }
});